import { useMerchant } from '../../../../hooks/useUser'

interface IFacebookAccessToken {
  userAccessToken: string
  pageAccessToken: string
}

const FacebookUserInfo = () => {
  const { config } = useMerchant<IFacebookAccessToken>('facebook')
  
  return <>User Info</>
}
export default FacebookUserInfo
